import {
  personComparison,
  validatePersonContacts,
  type ContactComparison,
} from "../../../../../../../_shared/_logic/contact-comparison"
import type { VerifyCustomerRow, VerifyCustomerDraft } from "../../../contract"
export const editorReason = (row: VerifyCustomerRow, draft: VerifyCustomerDraft): string | null =>
  !row.needsStep
    ? "Diese Zeile ist bereits abgeschlossen."
    : draft.decision === "skip"
      ? "Ignorierte Angaben werden nicht übernommen."
      : null
export const validateDraft = (
  row: VerifyCustomerRow,
  draft: VerifyCustomerDraft,
): string | null => {
  if (!draft.decision) return "Bitte wählen Sie eine Ansprechpartner-Entscheidung aus."

  if (draft.decision === "skip") return null

  if (
    draft.decision === "use_existing" &&
    !row.customerOptions.some((person) => person.customerId === draft.customerId)
  )
    return "Bitte wählen Sie einen bestehenden Ansprechpartner aus."

  if (draft.decision === "create_new" && !draft.displayName.trim())
    return "Bitte geben Sie einen Namen für den neuen Ansprechpartner ein."

  return validatePersonContacts(draft)
}
export const previousComparisons = (row: VerifyCustomerRow): ContactComparison[] =>
  row.existingCustomers.length
    ? row.existingCustomers.map((person) =>
        personComparison({
          ...person,
          side: "Bisherige Ansprechpartner",
          unit: `${row.addressLabel} · ${row.unitLabel}`,
        }),
      )
    : [
        personComparison({
          side: "Bisherige Ansprechpartner",
          displayName:
            row.previousCustomersStored === false
              ? "Bisherige Angaben nicht gespeichert"
              : "Kein Ansprechpartner hinterlegt",
          role: "",
          email: "",
          phone: "",
          unit: `${row.addressLabel} · ${row.unitLabel}`,
        }),
      ]
export const comparison = (
  row: VerifyCustomerRow,
  draft: VerifyCustomerDraft,
): ContactComparison => {
  const selected =
    draft.decision === "use_existing"
      ? row.customerOptions.find((person) => person.customerId === draft.customerId)
      : null

  return personComparison({
    ...draft,
    displayName: selected?.displayName || draft.displayName,
    email: draft.email,
    phone: draft.phone,
    side: "Neuer Ansprechpartner",
    unit: `${row.addressLabel} · ${row.unitLabel}`,
    origin: row.sourceLabel,
    original: [row.submittedName, row.submittedEmail, row.submittedPhone, row.suggestedRole]
      .filter(Boolean)
      .join(" · "),
    state: row.isResolved ? "Gespeichertes Ergebnis" : "Übernahmeentwurf",
    hint: draft.decision === "skip" ? "Wird nicht übernommen" : undefined,
  })
}
